/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_cognito_identity_pool_id": "eu-west-2:564c10ca-6cac-4072-8460-366f29b879ce",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_iyk1PEigL",
    "aws_user_pools_web_client_id": "20dtk46nfcoehbqru3fbbd2ofq",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "apiKeysMainRest",
            "endpoint": "https://kc4pyxl0u2.execute-api.eu-west-2.amazonaws.com/master",
            "region": "eu-west-2"
        }
    ]
};


export default awsmobile;
